module.exports = __webpack_public_path__ + "static/img/how_to_play.e6f6914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/how_to_play.png
// module id = QcQi
// module chunks = 1